<template>
  <div class="refinement-category">
    <div v-show="showTitle" class="title">{{ dropdownFilter.label }}</div>
    <div class="refinement-dropdown">
      <div class="select-style">
        <select
          :id="dropdownFilter.name"
          :name="dropdownFilter.name"
          :value="dropdownFilter.value"
          :aria-label="dropdownFilter.label"
          @change="updateDropdown"
        >
          <option value="">Select One</option>
          <option v-for="item in dropdownFilter.items" :key="item.value" :value="item.value">
            {{ item.label }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * Dropdown filters
 * [x] No errors on plans page that doesn't have any
 * [x] The tag is correctly created for the dropdown
 * [x] The url is correctly built for them
 * [x] On load from url args, correctly built to pinia and to ui
 * [x] URL loads tag
 * [x] Clearing specific tag clears pinia and UI
 * [x] Clear all from tags clears pinia and UI
 * [x] Clear all from mobile filters clears pinia and UI
 */
import _debounce from 'lodash/debounce'
import { useSearchStore } from '@/stores/search'
import type { DropdownFilter } from '@/types/search-types'

/** PROPS **/
const props = withDefaults(
  defineProps<{
    dropdownFilter: DropdownFilter
    showTitle?: boolean
  }>(),
  {
    showTitle: true,
  },
)

/** STATE **/
const searchStore = useSearchStore()

/** EMITS **/
const emit = defineEmits(['dropdown-change'])

/** METHODS **/
const updateDropdown = _debounce((e: InputEvent) => {
  if (!props.dropdownFilter.items || !(e.target instanceof HTMLSelectElement)) {
    return
  }

  const value = e.target.value

  // update store
  searchStore.setDropdownValue({
    filterName: props.dropdownFilter.name,
    value,
  })

  // single value only supported, multiple values not supported in this component, only userTags
  const selectedOption = props.dropdownFilter.items.find((item) => item.value === value)

  const tag = searchStore.dropdownTagItem({
    id: props.dropdownFilter.name,
    filterName: props.dropdownFilter.name,
    tagLabel: selectedOption ? selectedOption.label : '',
    value,
  })

  // pass to parent
  emit('dropdown-change', tag)
}, 250)
</script>
